import React, { useCallback, useEffect, useRef, useState } from 'react';
import useEmblaCarousel from 'embla-carousel-react';
import { EmblaCarouselArrowButton } from './EmblaCarouselArrowButton.tsx';
import { SquaresArrow } from '../SquaresArrow.tsx';
export const EmblaCarousel = ({ items, itemWidth, itemsGap, tailItem, tailItemWidth }) => {
    const [prevBtnDisabled, setPrevBtnDisabled] = useState(true);
    const [nextBtnDisabled, setNextBtnDisabled] = useState(false);
    const [selectedIndex, setSelectedIndex] = useState(0);
    const [scrollSnaps, setScrollSnaps] = useState([]);
    const [showButtons, setShowButtons] = useState(true);
    const buttonsContainerRef = useRef(null);
    // Initialize Embla Carousel with options
    const [emblaRef, emblaApi] = useEmblaCarousel({
        align: 'start',
        containScroll: 'trimSnaps',
        loop: false,
        dragFree: true,
        startIndex: 0,
        watchDrag: true
    });
    const scrollPrev = useCallback(() => emblaApi && emblaApi.scrollPrev(), [emblaApi]);
    const scrollNext = useCallback(() => emblaApi && emblaApi.scrollNext(), [emblaApi]);
    const onSelect = useCallback(() => {
        if (!emblaApi)
            return;
        setPrevBtnDisabled(!emblaApi.canScrollPrev());
        setNextBtnDisabled(!emblaApi.canScrollNext());
        setSelectedIndex(emblaApi.selectedScrollSnap());
    }, [emblaApi]);
    const checkShowButtons = useCallback(() => {
        if (!buttonsContainerRef.current) {
            return false;
        }
        if (!Array.isArray(items) || items.length === 0) {
            return false;
        }
        const totalElementWidth = itemWidth + itemsGap;
        let totalWidth = items.length * totalElementWidth + (tailItem ? tailItemWidth || 0 : 0);
        if (!tailItem) {
            totalWidth -= itemsGap;
        }
        setShowButtons(totalWidth > buttonsContainerRef.current.offsetWidth);
    }, [
        buttonsContainerRef.current,
        items,
        tailItem,
        itemWidth,
        itemsGap,
        tailItemWidth
    ]);
    useEffect(() => {
        if (!emblaApi)
            return;
        onSelect();
        setScrollSnaps(emblaApi.scrollSnapList());
        checkShowButtons();
        emblaApi.on('select', onSelect);
        emblaApi.on('reInit', onSelect);
        emblaApi.on('resize', checkShowButtons);
    }, [emblaApi, onSelect]);
    const totalElementWidthPx = `${itemWidth + itemsGap}px`;
    const gapPaddingPx = `${itemsGap}px`;
    return (React.createElement("div", null,
        React.createElement("div", { className: "mx-auto overflow-visible" },
            React.createElement("div", { className: "w-full" },
                React.createElement("div", { className: "relative" },
                    React.createElement("div", { className: "overflow-visible scroll-smooth", style: { WebkitOverflowScrolling: 'touch' }, ref: emblaRef },
                        React.createElement("div", { className: "flex" },
                            React.Children.toArray(items).map((childrenNode, index) => {
                                return (React.createElement("div", { key: index, className: `flex min-w-0 shrink-0`, style: {
                                        width: totalElementWidthPx,
                                        paddingRight: gapPaddingPx
                                    } }, childrenNode));
                            }),
                            !!tailItem && tailItem))))),
        React.createElement("div", { ref: buttonsContainerRef, className: "flex justify-end gap-6 mt-6 @container max-w-[1390px] mx-auto" }, showButtons && (React.createElement(React.Fragment, null,
            React.createElement(EmblaCarouselArrowButton, { onClick: scrollPrev, disabled: prevBtnDisabled, ariaLabel: "Previous slide", icon: React.createElement(SquaresArrow, { direction: "left", viewBox: "0 0 27 35", width: 20, height: 25, className: "mr-[4px]" }) }),
            React.createElement(EmblaCarouselArrowButton, { onClick: scrollNext, disabled: nextBtnDisabled, ariaLabel: "Next slide", icon: React.createElement(SquaresArrow, { viewBox: "0 0 24 32", width: 20, height: 25, className: "ml-[4px]" }) }))))));
};
